import { createOrderDetailsSlice } from 'common/stores/redux/OrderDetails';

const contractorOrderDetailsSlice = createOrderDetailsSlice(
    'contractorOrderDetails'
);

export const {
    init,
    replace,
    update,
    resetPages,
    initializeRoute,
    updateKeyValuePair,
    addNote,
    initFinancialInformation,
    updatePayment,
    updateBilling,
    updateNote,
    updateSpecialInstructions,
    addContact,
    removeContact,
    addComment,
    updateComment,
    addFolderAttachment,
    removeFolderAttachment,
    updateFulfillmentLogistics,
    setFinanceEdit,
    updateFulfillmentDetails,
} = contractorOrderDetailsSlice.actions;

export default contractorOrderDetailsSlice.reducer;
